import React, { useEffect, useRef, useState } from "react";
import "react-calendar/dist/Calendar.css";
import { Button, Container, Pagination, Table } from "react-bootstrap";
import search_icon from "../assets/search_icon.svg";

import "./Main.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChartLine,
  faPlus,
  faDownload,
  faSort,
  faEdit,
  faRefresh,
  faEye,
} from "@fortawesome/free-solid-svg-icons";
import SidebarContent from "./Sidebar";
import CryptoJS from "crypto-js";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../utils/axiosInstance";
// const apiEN = process.env.REACT_APP_GES1;
const apiDE = process.env.REACT_APP_GES3;

export default function FileStatus() {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [isSortFieldDBVisible, setisSortFieldDBVisible] = useState(false);
  const [SortFieldDB, setSortFieldDB] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [totalCount, setTotalCount] = useState(0);
  const [columns, setcolumns] = useState(null);
  const navigate = useNavigate();
  const keys = [
    "id",
    "fileName",
    "fileSize",
    "uploadStatus",
    "processingStatus",
    "uploadTimestamp",
    "processingTimestamp",
    "affectedRows",
    "tableName",
    "UploadedBy",
    "skippedRows",
  ];

  function TableStatus({ text }) {
    const textx = text?.toLowerCase();
    // console.log(textx);
    // console.log(textx === 'failed');
    const color =
      textx === "failed"
        ? "#EB5757"
        : textx === "cancelled"
        ? "#F2994A"
        : "#12A474";
    const bgcolor =
      textx === "failed"
        ? "#FFDBDB"
        : textx === "cancelled"
        ? "#FFF3DB"
        : "#BBF3E0";
    return (
      <span
        style={{
          backgroundColor: bgcolor,
          color: color,
          fontSize: 12,
          paddingTop: 5,
          paddingBottom: 5,
          paddingLeft: 10,
          paddingRight: 10,
          borderRadius: 8,
          textTransform: "capitalize",
        }}
      >
        {text}
      </span>
    );
  }

  const [sortOrder, setSortOrder] = useState(null);
  const [data, setdata] = useState(null);
  const [editMode, seteditMode] = useState(false);

  const handlePageChange = (value) => {
    setPage(value);
  };
  const pageCount = Math.ceil(totalCount / pageSize);

  const fetchData = async () => {
    try {
      var email = localStorage.getItem("email");
      setIsLoading(true);
      console.log({
        sortField: SortFieldDB,
        searchValue: searchValue,
      });
      await axiosInstance({
        url: process.env.REACT_APP_API_LINK + `/v1/getBulkUploadFileStatus`,
        method: "POST",
        responseType: "json",
        // withCredentials: true,

        data: {
          sortField: SortFieldDB,
          searchValue: searchValue,
          page: page,
          sortOrder: !sortOrder ? "asc" : sortOrder,
        },
      }).then((response) => {
        if (response) {
          console.log(response.data);

          var datax = response.data.data;
          console.log(datax);
          // datax = datax.FileStatus;
          console.log(datax);
          console.log(typeof datax);
          setdata(datax);
          if (datax && datax?.length > 0) {
            setTotalCount(response.data.totalCount);
            setcolumns(Object.keys(datax[0]));
          }
        }
      });
    } catch (err) {
      console.log("error fetching ");
      alert("error fetching data");
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (SortFieldDB || searchValue) {
      fetchData();
    }
  }, [SortFieldDB, searchValue, sortOrder, page]);

  const handleSort = (field) => {
    console.log(field);
    console.log(SortFieldDB);
    console.log(sortOrder);
    if (field === SortFieldDB) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortFieldDB(field);
      setSortOrder("asc");
    }
  };
  const pageNumbers = [];
  for (let i = 1; i <= pageCount; i++) {
    pageNumbers.push(i);
  }

  const getPageItems = () => {
    const items = [];

    // Add Prev button
    items.push(
      <Pagination.Prev
        key="prev"
        onClick={() => {
          if (page > 1) {
            handlePageChange(page - 1);
          }
        }}
        disabled={page <= 1}
      />
    );

    // Add page numbers
    for (
      let i = Math.max(1, page - 4);
      i <= Math.min(pageCount, page + 5);
      i++
    ) {
      items.push(
        <Pagination.Item
          key={i}
          active={page === i}
          onClick={() => handlePageChange(i)}
        >
          {i}
        </Pagination.Item>
      );
    }

    // Add Next button
    items.push(
      <Pagination.Next
        key="next"
        onClick={() => {
          if (page < pageCount) {
            handlePageChange(page + 1);
          }
        }}
        disabled={page >= pageCount}
      />
    );

    return items;
  };

  const NavV = () => {
    return (
      <p
        className="align-self-end"
        style={{
          padding: "2%",
          display: "flex",
          backgroundColor: "white",
          margin: 0,
          marginTop: "0rem",
          flexDirection: "row",
          alignItems: "center",

          // , marginBottom: 20
        }}
      >
        <p
          className="align-self-end"
          style={{
            margin: 0,
            marginTop: "0rem",
            marginLeft: "0.51rem",
            fontWeight: "700",
            cursor: "pointer",
          }}
          onClick={() => {
            navigate("/FileStatus");
          }}
        >
          {"File Status"}
        </p>
      </p>
    );
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-start",
        width: "100%",
        backgroundColor: "#ffffffff",
      }}
    >
      <SidebarContent />

      <>
        {data?.length > 0 && data != null && !isLoading ? (
          <>
            <Container
              fluid
              style={{
                maxWidth: "85%",
                boxSizing: "border-box", // include padding in width
              }}
            >
              <NavV />
              <div
                style={{
                  display: "flex",
                  margin: 0,
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                {/* <h1
                                style={{
                                    display: "inline-block",
                                    width: "27%",
                                    fontSize: "1rem",
                                    fontWeight: "700",
                                }}
                            >
                                FileStatus
                            </h1> */}
                <div
                  className="d-flex flex-wrap"
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "stretch",
                  }}
                >
                  <div
                    className="customx-input-group"
                    style={{ maxWidth: 800 }}
                  >
                    <img
                      src={search_icon}
                      alt=""
                      width={40}
                      style={{
                        padding: 10,
                      }}
                      id="basic-addon1"
                    />
                    <input
                      type="text"
                      className="customx-form-control"
                      style={{
                        minWidth: 400,
                      }}
                      value={searchValue}
                      onChange={(event) => setSearchValue(event.target.value)}
                      placeholder="Search here"
                    />
                  </div>

                  <button
                    className="custButton"
                    // className="custButton"
                    style={{
                      position: "relative",
                      backgroundColor: "white",
                      border: "none",
                    }}
                    onClick={() => {
                      setisSortFieldDBVisible(!isSortFieldDBVisible);
                    }}
                  >
                    <p className="custButton-text">
                      {SortFieldDB ? SortFieldDB : "Select Sort"}
                    </p>
                    <FontAwesomeIcon
                      icon={faSort}
                      className="custButton-icon"
                    />
                    {isSortFieldDBVisible && (
                      <div className="calendar-container">
                        <div className="FilterDropDown-menu">
                          {keys.map((key) => (
                            <span
                              key={key}
                              className="FilterDropDown-item-text"
                              onClick={() => {
                                setSortFieldDB(key);
                              }}
                            >
                              {key}
                            </span>
                          ))}
                        </div>
                      </div>
                    )}
                  </button>
                  {/* <div className="custButton"
                                   onClick={() => downloaddata()}>
                                    <p className="custButton-text">Download</p>
                                    <FontAwesomeIcon icon={faDownload} className="custButton-icon" />
                                </div> */}
                  <div className="custButton" onClick={() => fetchData()}>
                    <p className="custButton-text">Refresh</p>
                    <FontAwesomeIcon
                      icon={faRefresh}
                      className="custButton-icon"
                    />
                  </div>
                </div>
              </div>
              <div style={{ overflowX: "auto" }}>
                <Table hover fluid responsive>
                  <thead>
                    <tr
                      style={{
                        color: "#809FB8",
                        borderBottomWidth: 1,
                        borderBottomColor: "#b4a7d6",
                        fontWeight: "600",
                        textTransform: "uppercase",
                        height: 50,
                        verticalAlign: "middle",
                      }}
                    >
                      {columns?.map((column) => (
                        <td
                          key={column}
                          onClick={() => {
                            // alert(column);
                            handleSort(column);
                          }}
                          style={{
                            cursor: "pointer",
                          }}
                        >
                          {column}
                        </td>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {data?.map((item, index) => (
                      <tr key={index}>
                        {columns.map((field, fieldindex) =>
                          field === "processingStatus" ? (
                            <td key={`${fieldindex}`}>
                              {" "}
                              <TableStatus text={item[field]} />
                            </td>
                          ) : (
                            <td
                              key={`${fieldindex}`}
                              style={{
                                color: "#06152B",
                                fontWeight: "400",
                                fontSize: "0.81rem",
                              }}
                            >
                              <p>{item[field]}</p>
                            </td>
                          )
                        )}
                      </tr>
                    ))}
                  </tbody>
                </Table>
                {/* Math.ceil(totalCount / pageSize) */}
                <Pagination style={{ float: "right" }}>
                  <Pagination.First onClick={() => handlePageChange(1)} />
                  {getPageItems()}
                  <Pagination.Last
                    onClick={() => handlePageChange(pageCount)}
                  />
                </Pagination>
              </div>
            </Container>
          </>
        ) : isLoading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignSelf: "center",
              height: "70vh",
              backgroundColor: "white",
            }}
          >
            <img src="./logo.png" draggable="false" className="lovin-it" />
            {/* <Spinner animation="border" /> */}
          </div>
        ) : (
          <>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignSelf: "center",
                alignItems: "center",
                height: "70vh",
                backgroundColor: "white",
              }}
            >
              <h3>No data found</h3>
            </div>
          </>
        )}
      </>
    </div>
  );
}
